/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Amount_UsedInputs */

const vi_care_log_amount_used = /** @type {(inputs: Care_Log_Amount_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng đã dùng`)
};

/**

* @param {Care_Log_Amount_UsedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_amount_used = /** @type {((inputs?: Care_Log_Amount_UsedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Amount_UsedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_amount_used(inputs)
});